exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#userinfo[data-v-3ccb94f9]{\n  width: 100%;\n  text-align: center;\n}\nh1[data-v-3ccb94f9]{\n  width: 80%;\n  margin: auto;\n  margin-top: 5px;\n}\ntable[data-v-3ccb94f9]{\n  margin: auto;\n  width: 90%;\n}\n.info[data-v-3ccb94f9]{\n  margin: auto;\n  padding: 2vw;\n  width: 90%;\n  border: solid 2px rgb(255, 200, 6);\n  border-radius: 7px;\n}\n.button[data-v-3ccb94f9]{\n  width: 50%;\n  height: 10vh;\n  margin: 10px;\n  border: solid 3px rgb(255, 148, 6);\n  border-radius: 5px;\n  background-color: rgb(255, 214, 125);\n  font-size:  7vw;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-3ccb94f9","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Mobile/UserInfo/Spchangeuserinfo.vue
// module id = 497
// module chunks = 0